export default {"src":"/_next/static/media/Room2.b1b953ea.svg","height":285,"width":330,"blurWidth":0,"blurHeight":0};